import React, { Component } from "react";
import theme from "../styles/theme";
import { ThemeProvider } from "@mui/styles";
import "../styles/style.css";
import { BlueButton } from "../components/BlueButton";
import { Button } from "@mui/material";
import BackButton from "@mui/icons-material/ArrowBackOutlined";
import { RefreshSession, GetToken } from "../services/Session";
import { CreateOrder } from "../services/Transaction";
import NumberFormat from "react-number-format";
import Divider from "@mui/material/Divider";

class TransactionConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  handleLanjutkan() {
    const { product_id, tickets } = this.props.location.state;
    this.setState({ loading: true });
    for (var i = 0; i < tickets.length; i++) {
      tickets[i] = { owner: tickets[i], student_id_number: tickets[i].student_id_number }
    }

    const params = {
      line_items: [{ product: { id: product_id }, tickets: tickets }],
    };
    CreateOrder(params)
      .then(res => {
        this.setState({ loading: false });
        this.props.history.push("/transaksi/" + res.data.id, res.data);
      })
      .catch(err => {
        this.setState({ loading: false });
        if (err.response) {
          if (err.response.status === 401) {
            if (GetToken().refresh_token !== null) {
              RefreshSession(GetToken().refresh_token);
              setTimeout(this.handleSubmit(), 5000);
            }
          } else if (
            err.response.data.error &&
            err.response.data.error &&
            err.response.data.error.message
          ) {
            alert(err.response.data.error.message);
            if (err.response.status === 402) {
              this.props.history.push("/transaksi");
            }
          } else {
            alert("gagal terhubung ke server");
          }
        } else {
          alert("gagal terhubung ke server");
        }
      });
  }

  renderTicket = ticketOwner => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start"
        }}
      >
        <Divider style={{ marginTop: 10, width: 320 }} />
        <div style={{ marginTop: 10, marginLeft: 10 }}>
          <span>Nama : </span>
          <span style={{ fontWeight: "bold" }}>{ticketOwner.name}</span>
        </div>
        <div style={{ marginTop: 5, marginLeft: 10 }}>
          <span>Jenis kelamin : </span>
          <span style={{ fontWeight: "bold" }}>
            {ticketOwner.gender === "male" ? "Laki-laki" : "Perempuan"}
          </span>
        </div>
        <div style={{ marginTop: 5, marginLeft: 10 }}>
          <span>Nomor Whatsapp: </span>
          <span style={{ fontWeight: "bold" }}>
            {ticketOwner.phone !== "" ? ticketOwner.phone : "-"}
          </span>
        </div>
        <div style={{ marginTop: 5, marginLeft: 10 }}>
          <span>Email: </span>
          <span style={{ fontWeight: "bold" }}>
            {ticketOwner.email !== "" ? ticketOwner.email : "-"}
          </span>
        </div>
        <div style={{ marginTop: 5, marginLeft: 10 }}>
          <span>NIP: </span>
          <span style={{ fontWeight: "bold" }}>
            {ticketOwner.student_id_number !== "" ? ticketOwner.student_id_number : "-"}
          </span>
        </div>
      </div>
    );
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <div className="header">
          <Button
            startIcon={<BackButton />}
            style={{
              position: "absolute",
              height: 60,
              width: 60,
              top: 0,
              left: 0
            }}
            onClick={() => {
              this.props.history.goBack();
            }}
          />
          <div className="center">
            <h3 className="title">Konfirmasi</h3>
          </div>
        </div>
        <div className="wrapper" ref={el => (this.container = el)}>
          <div
            className="confirmation"
            style={{
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <div style={{ marginTop: 10, marginLeft: 10 }}>Rincian</div>
            <Divider style={{ marginTop: 5, marginBottom: 5, width: 320 }} />
            <div style={{ marginTop: 10, marginLeft: 10 }}>
              {this.props.location.state.product_name}
            </div>
            <div style={{ marginTop: 10, marginLeft: 10 }}>
              {this.props.location.state.product_description}
            </div>
            <div
              style={{
                marginTop: 5,
                marginLeft: 10,
                alignSelf: "flex-end",
                marginRight: 10
              }}
            >
              {this.props.location.state.quantity} x <NumberFormat value={this.props.location.state.unit_price} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} /> = <NumberFormat value={this.props.location.state.total} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} />
            </div>
            <div style={{ marginTop: 5, marginLeft: 10, fontStyle: "italic" }}>
              Atas nama:
            </div>
            {this.props.location.state.tickets.map(ticketOwner =>
              this.renderTicket(ticketOwner)
            )}
            <div style={{ height: 20 }}></div>
          </div>
        </div>
        <div className="footer" style={{ height: 90 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 5
            }}
          >
            <div style={{ alignSelf: "center", fontFamily: 'Roboto' }}>
              {`Jumlah yang akan dibayarkan : ${"\u00a0"}`}
            </div>
            <div style={{ color: "#00bfe6", fontSize: 20, fontFamily: 'Roboto' }}>
              <NumberFormat
                value={this.props.location.state.total}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"Rp "}
              />
            </div>
          </div>
          <BlueButton
            disabled={this.state.loading}
            loading={this.state.loading}
            onClick={() => {
              this.handleLanjutkan();
            }}
            text="Bayar"
          />
        </div>
      </ThemeProvider>
    );
  }
}

export default TransactionConfirmation;
